import React, { Component, PropTypes } from 'react';

import './formHeading.scss';

export default class FormHeading extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    render() {
        let {className, children} = this.props;
        return (
            <div className={`form-heading ${className ? className : ""}`}>
                {children}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/views/formHeading/FormHeading.js